import React, { useEffect, useState } from "react";
import * as theme from "../../theme";
import Select from "react-dropdown-select";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Zoom, Tooltip } from "@material-ui/core";
import DatePicker from "./Date";
import { Constents } from "./Constant";
import AddEditCovers from "./AddEditCovers";
import { getResponseDetail } from "../../store/quotes";
import CloudIcon from "./CloudIcon";
import translations from "../../utils/translations";
import { getBrokerInformation } from "../../store/broker";

const AddEditSummary = ({
  card,
  setValue,
  isEditBinder,
  onSubmit,
  handleSubmit,
  responseid,
}) => {
  // const tempCard = card.map((data) => {
  //   return {
  //     ...data,
  //     name: { en: data.name, fr: data.frname },
  //     definition: { en: data.definition, fr: data.frdefinition },
  //   };
  // });
  const tempCard = card;
  const responseDetail = useSelector(getResponseDetail(responseid));
  const [isUpdating, setUpdating] = useState(false);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const addEditTranslations = translations[languagepreference];
  return (
    <div>
      <form
        id="form"
        onSubmit={
          responseid != undefined
            ? null
            : handleSubmit && handleSubmit(onSubmit)
        }
      >
        <div style={{ display: "flex" }}>
          <Typography
            variant="h5"
            component="h5"
            style={{ ...theme.labelStyles }}
          >
            {responseid != undefined
              ? Constents.PROSPECT_TITLE[languagepreference]
              : Constents.BINDER_TITLE[languagepreference]}
          </Typography>
          {responseid != undefined ? (
            <CloudIcon style={{ marginLeft: "10px" }} isUpdating={isUpdating} />
          ) : null}
        </div>

        <div>
          {true && tempCard ? (
            Object.values(tempCard).map((coverid, index) =>
              coverid?.name["en"] != "Comment" &&
              (responseid != undefined
                ? coverid?.name["en"]
                : coverid?.name["en"] != "Quote expiry date" &&
                  coverid?.name["en"] != "Insurer Response" &&
                  coverid?.name["en"] != "Quote reference") ? (
                <div
                  key={index}
                  style={{
                    fontFamily: "GibsonLight",
                    display: "flex",
                    margin: ".5rem auto",
                  }}
                >
                  <Tooltip
                    TransitionComponent={Zoom}
                    title={coverid.definition[languagepreference]? coverid.definition[languagepreference]:coverid.definition}
                    style={{
                      width: "300px",
                      fontSize: ".675rem",
                    }}
                  >
                    <label
                      className="col-sm-7 col-form-label"
                      style={{
                        fontFamily: "GibsonRegular",
                        display: "flex",
                        marginTop: "2px",
                        paddingLeft: "5px",
                      }}
                    >
                      {coverid.name[languagepreference]}
                    </label>
                  </Tooltip>
                  {coverid.name["en"] == "Insurer Response" ? (
                    <div style={{ width: "100%" }}>
                      <Select
                        length="20px"
                        className="form-control"
                        options={[
                          {
                            value: "Quote",
                            label: addEditTranslations.optionQuote,
                          },
                          {
                            value: "Refer",
                            label: addEditTranslations.optionRefer,
                          },
                          {
                            value: "Decline",
                            label: addEditTranslations.optionDecline,
                          },
                          {
                            value: "Pending",
                            label: addEditTranslations.optionPending,
                          },
                        ]}
                        values={
                          coverid.covervalue
                            ? [
                                {
                                  value: coverid.covervalue,
                                  label: coverid.covervalue,
                                },
                              ]
                            : [
                                {
                                  value: "Pending",
                                  label: addEditTranslations.optionPending,
                                },
                              ]
                        }
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        onChange={function (event) {
                          setTimeout(() => {
                            setUpdating(true);
                            setValue({
                              value: event[0].value,
                              id: coverid.id,
                            });
                            setUpdating(false);
                          }, 400);
                        }}
                        disabled={
                          responseid != undefined
                            ? responseDetail?.source == "manual"
                              ? false
                              : true
                            : isEditBinder
                        }
                      />
                    </div>
                  ) : ["currency", "percent", "percent2f"].includes(
                      coverid.inputvaluetype
                    ) ? (
                    <AddEditCovers
                      coverid={coverid}
                      setValue={setValue}
                      isEditBinder={isEditBinder}
                      setUpdating={setUpdating}
                      responseid={responseid}
                      responseDetail={responseDetail}
                    />
                  ) : coverid?.name["en"] == "Quote reference" ||
                    coverid.inputvaluetype.toLowerCase() == "string" ? (
                    <input
                      className="form-control"
                      type={
                        coverid.inputvaluetype
                          ? coverid.inputvaluetype.toLowerCase() == "string"
                          : "text"
                      }
                      onBlur={(event) => {
                        setTimeout(() => {
                          setUpdating(true);
                          setValue({
                            value: event.target.value,
                            id: coverid.id,
                          });
                          setUpdating(false);
                        }, 400);
                      }}
                      placeholder={" - "}
                      defaultValue={coverid.covervalue}
                      disabled={
                        responseid != undefined
                          ? responseDetail?.source == "manual"
                            ? false
                            : true
                          : isEditBinder
                      }
                    />
                  ) : responseid != undefined ||
                    coverid?.name["en"] != "Quote expiry date" ? (
                    <DatePicker
                      setValue={setValue}
                      isEditBinder={isEditBinder}
                      responseid={responseid}
                      id={coverid?.id}
                      quotesExpiry={coverid?.covervalue}
                      responseDetail={responseDetail}
                    ></DatePicker>
                  ) : null}
                </div>
              ) : null
            )
          ) : (
            <div />
          )}
          {responseid != undefined || null ? null : (
            <DatePicker
              setValue={setValue}
              isEditBinder={isEditBinder}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
            ></DatePicker>
          )}
        </div>
      </form>
    </div>
  );
};

export default AddEditSummary;
